import { badgePrefixCls } from "@/base/components/badge/Badge.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Badge">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${badgePrefixCls}`]: {},
  },
});

export const useBadgeStyle = genComponentStyleHook(
  ["Badge", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
